export default "__VITE_ASSET__B5yLQ0P9__"